package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.badge.Badge
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeType
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.expand
import inspection.composeapp.generated.resources.ic_arrow_down
import inspection.composeapp.generated.resources.ic_arrow_up
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun AnswerSummaryHeader(
    verticalPadding: Dp,
    horizontalPadding: Dp,
    expand: Boolean,
    title: String,
    totalItems: Int,
    hideExpandIcon: Boolean = false,
) {
    val color: ThemeColor = LocalAppTheme.current.color
    val dimension = LocalAppTheme.current.dimension

    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(
                vertical = verticalPadding,
                horizontal = horizontalPadding
            ),
        horizontalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space2
        )
    ) {
        if (!hideExpandIcon) {
            Icon(
                painter = painterResource(
                    if (expand) Res.drawable.ic_arrow_up else Res.drawable.ic_arrow_down
                ),
                tint = color.icon.subtle,
                contentDescription = stringResource(Res.string.expand)
            )
        }

        TextBodySmall(
            text = title,
            bold = true,
            modifier = Modifier.weight(1f)
        )

        Badge(
            type = BadgeType.RED,
            strong = true,
            label = totalItems.toString(),
        )
    }
}
